/**
 * UTILITY FUNCTION TO MEASURE NAMED TIME SLOTS
 */
(function(global, methodName) {
    var BasicTimer = {
        logToConsole: true,
        startTimes: {},
        durations: {},
        runningTimers: {},
        callbacks: {},
        start: function(name) {
            if (!name) {
                name = '__default__';
            }
            var isRunning = typeof BasicTimer.runningTimers[name] !== 'undefined' && BasicTimer.runningTimers[name];
            if (!isRunning) {
                BasicTimer.runningTimers[name] = true;
                BasicTimer.startTimes[name] = typeof window.performance !== 'undefined' ? performance.now() : Date.now();
            } else {
                BasicTimer.logToConsole && window.console && console.warn('Timer ' + name + ' is already running, ignoring');
            }
        },
        stop: function(name) {
            if (!name) {
                name = '__default__';
            }
            if (!BasicTimer.startTimes[name]) {
                BasicTimer.logToConsole && window.console && console.warn('Timer ' + name + ' was never started');
                return;
            }
            var isRunning = typeof BasicTimer.runningTimers[name] !== 'undefined' && BasicTimer.runningTimers[name];
            if (isRunning) {
                BasicTimer.runningTimers[name] = false;
                var now = typeof window.performance !== 'undefined' ? performance.now() : Date.now();
                var elapsed = now - BasicTimer.startTimes[name];
                BasicTimer.logToConsole && window.console && console.log('Timer ' + name + ' stopped. Elapsed, ' + elapsed + ' ms');
                if (typeof BasicTimer.callbacks[name] !== 'undefined' && BasicTimer.callbacks[name].length > 0) {
                    for (var i = 0; i < BasicTimer.callbacks[name].length; i++) {
                        if (typeof BasicTimer.callbacks[name][i] === 'function') {
                            BasicTimer.callbacks[name][i](elapsed, name);
                        }
                    }
                }
                return elapsed;
            } else {
                BasicTimer.logToConsole && window.console && console.warn('Timer ' + name + ' is not running');
            }
        },
        onStop: function(name, callback) {
            if (!name) {
                name = '__default__';
            }
            if (typeof BasicTimer.callbacks[name] === 'undefined') {
                BasicTimer.callbacks[name] = [];
            }
            BasicTimer.callbacks[name].push(callback);
        },
        reset: function(name) {
            if (!name) {
                name = '__default__';
            }
            delete BasicTimer.startTimes[name];
            delete BasicTimer.durations[name];
            delete BasicTimer.runningTimers[name];
            delete BasicTimer.callbacks[name];
        }
    };
    global[methodName] = BasicTimer;
})(window, 'DEBasicTimer');


/**
 * LOADS GRAFANA FARO RUM
 */
(function () {
    // Create a script tag for loading the library
    var script = document.createElement('script');
    // Initialize the Web SDK at the onLoad event of the script element so it is called when the library is loaded.
    script.onload = () => {
        // Injects the correct page path in RUM events
        function injectPagePath(event) {
            if (event.type == 'measurement' || event.type == 'event') {
                try {
                    event.meta.page.id = event.meta.page.url ? location.pathname : undefined ;
                } catch (e) {
                    console.log('error: ' + e);
                }
            }
            return event;
        }
        // Initializes the Grafana RUM library in the global variable DE_GrafanaFaroInstance
        window.DE_GrafanaFaroInstance = window.GrafanaFaroWebSdk.initializeFaro({
            // Mandatory, the URL of the Grafana Cloud collector with embedded application key.
            url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/0da43b3fa7ea8c2dcf44f68b31cd9efe',
            // Mandatory, the identification label(s) of your application
            app: {
                name: 'makkah-madinah',
                version: '1.0.0',
                environment: (window.location.hostname === 'makkah-madinah.accor.com') ?  'production' : 'staging'
            },
            beforeSend: injectPagePath
        });
    };
    // Set the source of the script tag to the CDN
    script.src = 'https://cdn.jsdelivr.net/npm/@grafana/faro-web-sdk@1.19.0/dist/bundle/faro-web-sdk.iife.min.js';

    // Append the script tag to the head of the HTML document
    document.head.appendChild(script);
})();

// Do not log to console timer activity
DEBasicTimer.logToConsole = false;
